// extracted by mini-css-extract-plugin
export default {"canvas":"styles_canvas__5-IOs"};